import React from 'react'
import { string } from 'prop-types'
import { MediaIframeEmbed } from '../MediaIframeEmbed'

export const Youtube = ({ channel, ...rest }) => {
  if (!channel) return null
  const id = channel

  return <MediaIframeEmbed src={`https://www.youtube.com/embed/${id}`} {...rest} />
}

Youtube.propTypes = {
  channel: string,
}
